import {
  Entity,
  EntityPermissionActivityKeys,
  type RoleEntityPermissionMap,
} from 'ag-common-lib/public-api';

/** Whether the viewer may edit report default settings (the gear on report tiles). ARM only. */
export function canManageReportDefaultSettingsOnArm(
  permissionsMap: RoleEntityPermissionMap | null | undefined,
): boolean {
  return !!permissionsMap?.[Entity.reportsGenerationPipeline]?.[EntityPermissionActivityKeys.write];
}
